import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as _ from "underscore";

import { GLOBAL_CONSTANT } from "../../../common/constant/global.constant";
import { locationBinderInterface } from "./location-binder.interface";
import { LocationBinderService } from "./service/api/location-binder.service";

@Component({
  selector: "app-location-binder",
  templateUrl: "./location-binder.component.html",
  styleUrls: ["./location-binder.component.scss"],
})
export class LocationBinderComponent implements OnInit {
  _data: locationBinderInterface;
  _readOnly: boolean = false;
  cityType: any;
  selectedCityType: any;
  villageFlag: boolean = false;
  cityFlag: boolean = false;
  orgValue: locationBinderInterface;
  id = 1;
  gatNumberId: any;

  @Output() onChange = new EventEmitter();
  @Input()
  set data(value) {
    if (value != null || value != undefined) {
      this._data = value;
    }
    if (!_.isEmpty(this._data)) {
      this.editableMode = true;
      if (this._data.cityType) {
        this._data.cityType = _.find(this.cityType, (a) => {
          return a.value === (this._data.cityType && this._data.cityType.value) || a.value === this._data.cityType;
        });
      }
      
      // Fixed with traditional null checks
      if (this._data.cityType) {
        if (this._data.cityType.label == "Village") {
          this.villageFlag = true;
          this.cityFlag = false;
          if (this._data.assembly && this._data.gaon && this._data.gaon.id) {
            this.getGaon(this._data.gaon.id);
          }
        } else {
          this.cityFlag = true;
          this.villageFlag = false;
          if (this._data.assembly && this._data.assembly.id) {
            this.getPrabhagList(this._data.assembly.id);
          }
        }
      }
  

      this.orgValue = JSON.parse(JSON.stringify(this._data));
    } else {
      this.orgValue = {};
    }
  }
  get data() {
    return this._data;
  }

  @Input()
  set readOnly(value) {
    if (value != null || value != undefined) {
      this._readOnly = value;
    }
  }
  get readOnly() {
    return this._readOnly;
  }

  editableMode: boolean = false;
  locationBinderObj: locationBinderInterface;

  //assembly, Gaon And Gat_number
  assemblyData: Array<any>;
  gaonData: Array<any>;
  gatNumberData: Array<any>;
  ganData: Array<any>;
  prabhagData: Array<any>;
  prabhagAreaData: Array<any>;

  constructor(private service: LocationBinderService) {
    this.cityType = GLOBAL_CONSTANT.CITY_TYPES;
  }

  //onChange methods
  onChangeAssembly(event) {
    this._data.assembly = event.value;
  }

  onChangeCityType(event) {
    this._data.cityType = event.value;

    if (event.value.value === "VILLAGE") {
      this.villageFlag = true;
      this.cityFlag = false;
      if (this._data.assembly) {
        this.getGaonList(this._data.assembly.id);
      }
    } else {
      this.cityFlag = true;
      this.villageFlag = false;

      if (this._data.assembly) {
        this.getPrabhagList(this._data.assembly.id);
      }
    }
  }

  onChangeGat(event) {
    this._data.gat_number = event.value;
  }

  onChangeGan(event) {
    // this._data.gan_number = event.value;
    this.getGatNoList(this.gatNumberId);
  }
  onChangeGaon(event) {
    this._data.gaon = event.value;
    this.gatNumberId = event.value.ganNumber.gatNumber.id;
    this.getGanList(event.value.ganNumber.id);
  }

  onChangePrabhag(event) {
    this._data.prabhag = event.value;
    this.getPrabhagAreaList(event.value.id);
  }

  onChangePrabhagArea(event) {
    this._data.prabhagArea = event.value;
  }
  //Assembly Data
  getAsseblyList() {
    this.service.getAssemblyData().subscribe((ele: any) => {
      this.assemblyData = ele;
      if (this.editableMode && this._data.assembly != null) {
        // this.getGatNoList(this._data.assembly.id);
        this.getCityType(this._data.assembly.id);
      }
    });
  }

  //Gat_number List
  getGatNoList(id) {
    this.service.getGatNumberData(id).subscribe((res: any) => {
      this.gatNumberData = res;
      // if (this.editableMode) {
      //   this.getGanList(this._data.gat_number.id);
      // }
    });
  }

  //Gan List
  getGanList(id) {
    this.service.getGanNumberData(id).subscribe((res: any) => {
      this.ganData = res;
      if (this.editableMode) {
        this.getGatNoList(this._data.gat_number.id);
      }
    });
  }

  //Gaon List
  getGaonList(id) {
    this.service.getGaonDataWithAssembly(id).subscribe((res: any) => {
      this.gaonData = res[0];

      // if (this.editableMode) {
      //   this.getGanList(this._data.gan_number.id);
      // }
    });
  }
  //Gaon List
  getGaon(id) {
    this.service.getGaonData(id).subscribe((res: any) => {
      this.gaonData = res;

      if (this.editableMode) {
        this.getGanList(this._data.gan_number.id);
      }
    });
  }

  //Prabhag
  getPrabhagList(id: number) {
    this.service.getPrabhagData(id).subscribe(
      (res: any) => {
        this.prabhagData = res;
        
        // Add proper null checks before accessing prabhag.id
        if (this.editableMode && this._data && this._data.prabhag && this._data.prabhag.id) {
          this.getPrabhagAreaList(this._data.prabhag.id);
        }
      },
      (error) => {
        console.error('Error fetching prabhag data:', error);
        // Handle error appropriately
      }
    );
  }

  // prabhag area
  getPrabhagAreaList(id) {
    this.service.getPrabhagAreaData(id).subscribe((res: any) => {
      this.prabhagAreaData = res;
    });
  }

  // city type
  getCityType(id) {
    // First check if _data exists and has the required properties
    if (!this._data) return;
  
    // Check cityType safely
    if (this._data.cityType && this._data.cityType.label === "Village") {
      this.villageFlag = true;
      this.cityFlag = false;
      
      // Safe check for assembly and gaon
      if (this._data.assembly && this._data.gaon && this._data.gaon.id) {
        this.getGaon(this._data.gaon.id);
      }
    } else {
      this.cityFlag = true;
      this.villageFlag = false;
      
      // Safe check for assembly
      if (this._data.assembly && this._data.assembly.id) {
        this.getPrabhagList(this._data.assembly.id);
      }
    }
  }

  ngOnInit() {
    setTimeout(() => this.getAsseblyList(), 500);
  }
}
